import { DialogActions, Typography } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

interface DialogActionsProps {
  readOnly: boolean;
  nomineeId?: string;
  resells: any[];
  bankAccountId: string;
  selectedCertificate: any;
  hasCessionIntegration: boolean;
  onEdit: () => void;
  onClose: () => void;
  onExitEdit: () => void;
  onSave: () => Promise<void>;
  onConfirm: () => Promise<void>;
  onConfirmAndCede: () => void;
  onDelete?: () => void;
  canDelete?: boolean;
}

const ResellDialogActions: React.FC<DialogActionsProps> = ({
  readOnly,
  nomineeId,
  resells,
  bankAccountId,
  selectedCertificate,
  hasCessionIntegration,
  onEdit,
  onClose,
  onExitEdit,
  onSave,
  onConfirm,
  onConfirmAndCede,
  onDelete,
  canDelete,
}) => {
  return (
    <DialogActions>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 0px',
          gap: '10px',
        }}
      >
        {canDelete && onDelete && (
          <Typography
            color="error"
            variant="body1"
            fontWeight="bold"
            style={{ cursor: 'pointer' }}
            onClick={onDelete}
          >
            Eliminar
          </Typography>
        )}

        <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto' }}>
          {readOnly && (
            <CustomButton onClick={onEdit} color="primary">
              Editar
            </CustomButton>
          )}

          <CustomButton
            onClick={readOnly ? onClose : nomineeId ? onExitEdit : onClose}
            color="secondary"
          >
            {readOnly ? 'Cerrar' : 'Salir'}
          </CustomButton>

          {!readOnly && (
            <>
              {nomineeId ? (
                <CustomButton
                  onClick={onSave}
                  color="primary"
                  disabled={resells.length === 0}
                >
                  Guardar
                </CustomButton>
              ) : (
                <>
                  <CustomButton
                    onClick={onConfirm}
                    color="primary"
                    disabled={resells.length === 0 || !bankAccountId}
                  >
                    Confirmar
                  </CustomButton>

                  <CustomButton
                    onClick={onConfirmAndCede}
                    color="primary"
                    disabled={
                      resells.length === 0 ||
                      !bankAccountId ||
                      !selectedCertificate ||
                      !hasCessionIntegration
                    }
                  >
                    Confirmar y ceder
                  </CustomButton>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </DialogActions>
  );
};

export default ResellDialogActions;
